module.exports = __webpack_public_path__ + "static/media/gradient-endX-icon.200dc645.svg";